import styled, { css } from 'styled-components';
import { getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/common';
import { Stack, StackProps } from '../Stack';
import { BreadcrumbItemProps } from './types';

export const Wrapper = styled(Stack)<StackProps & { small?: boolean }>`
    ${getTextTokenPreset('titleLarge')};
    color: ${getToken('textStaticSecondary')};

    ${(props) =>
        props.small &&
        css`
            ${getTextTokenPreset('titleMedium')};
        `}
`;

const BreadcrumbItemBase = styled.a<BreadcrumbItemProps>`
    ${getTextTokenPreset('titleLarge')};
    color: ${getToken('textStaticSecondary')};
    height: ${getToken('sizing400')}px;
    border-radius: ${getToken('borderRadius100')}px;
    padding: 0 ${getSpacingToken('100')}px;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    box-sizing: border-box;
    white-space: nowrap;

    ${(props) =>
        props.small &&
        css`
            ${getTextTokenPreset('titleMedium')};
        `}

    ${(props) =>
        props.active
            ? css`
                  ${props.small ? getTextTokenPreset('titleMediumStrong') : getTextTokenPreset('titleLargeStrong')};
                  color: ${getToken('textStaticPrimary')};
              `
            : css`
                  &:hover {
                      background: ${getToken('backgroundInteractiveNeutralSubtleHover')};
                      color: ${getToken('textStaticPrimary')};
                  }
              `}
`;

export const BreadcrumbItem = <T extends BreadcrumbItemProps>(props: T & BreadcrumbItemProps) => (
    <BreadcrumbItemBase {...props} />
);
